import { fetchJSON as fetchAPI } from './client';

const RUNTIME_BASE = import.meta.env.VITE_RUNTIME_API ?? 'http://localhost:8159';

export type AggregateOwnership = {
  aggregate: string;
  owner: string;
  repository: string;
  schema: string;
  event_publisher: string;
  api_prefix: string;
};

export type ServiceEntry = {
  service_id: string;
  role: string;
  canonical_id?: string;
  port?: number;
  description?: string;
};

export type RemediationStatus = {
  blk001_resolved: boolean;
  adapters_registered: number;
  ops_orchestration: number;
  intel_consumers: number;
  canonical_modules: number;
  dependency_valid: boolean;
};

export type ArchitectureRegistry = {
  ownership: AggregateOwnership[];
  amazon_adapters: ServiceEntry[];
  ops_orchestration: ServiceEntry[];
  intelligence_consumers: ServiceEntry[];
  legacy_mapping: Record<string, string>;
};

function fetchRuntime<T>(path: string): Promise<T> {
  return fetchAPI<T>(RUNTIME_BASE, path);
}

export const canonicalApi = {
  registry: () => fetchRuntime<ArchitectureRegistry>('/api/v1/canonical/registry'),
  ownership: () => fetchRuntime<{ ownership: AggregateOwnership[] }>('/api/v1/canonical/ownership'),
  adapters: () => fetchRuntime<{ amazon: ServiceEntry[]; ops: ServiceEntry[]; intel: ServiceEntry[] }>('/api/v1/canonical/adapters'),
  remediation: () => fetchRuntime<RemediationStatus>('/api/v1/canonical/remediation'),
  serviceEnforcement: (id: string) => fetchRuntime<{ valid: boolean; canonical_owner?: string; adapter_mode?: boolean }>(`/api/v1/canonical/services/${id}`),
};
